import { QueryClientProvider } from '@tanstack/react-query';
import { type ReactNode, useState } from 'react';
import { BrowserRouter } from 'react-router';

import { createQueryClient } from '@/api/queryClient';

import { ErrorBoundary } from './ErrorBoundary';

/**
 * Everything the whole app needs, in one place.
 *
 * The query client is created in state so React never recreates it on a
 * re-render, which would silently drop the entire cache.
 */
export function AppProviders({ children }: { children: ReactNode }) {
    const [queryClient] = useState(createQueryClient);

    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>{children}</BrowserRouter>
            </QueryClientProvider>
        </ErrorBoundary>
    );
}
